module.exports = __webpack_public_path__ + "static/media/about-front.c4a8cf4e.png";